var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"finance"},[_vm._v(" Finance "),_c('DataTable',{staticClass:"history-table",attrs:{"header-fields":_vm.fields,"data":_vm.data || [],"css":_vm.css,"not-found-msg":_vm.$t('profile.history_page.no_history')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }